import { useRef, useState, type FormEvent } from "react";
import { Link } from "react-router";
import { SUPPORT_EMAIL } from "@handvero/shared";
import { api, errorText } from "../api";
import { Field, Notice } from "./ui";

/** Kontaktformular der Website. Die Anfrage kommt als Kundenanfrage im HandVero-Postfach an. */
export function ContactForm() {
  const openedAt = useRef(Date.now());
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);

  async function submit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const f = new FormData(e.currentTarget);
    setBusy(true);
    setError("");
    try {
      await api.post("/api/contact", {
        name: String(f.get("name") ?? ""),
        email: String(f.get("email") ?? ""),
        message: String(f.get("message") ?? ""),
        website: String(f.get("website") ?? ""),
        source: "website",
        formMs: Date.now() - openedAt.current,
      });
      setSent(true);
    } catch (err) {
      setError(errorText(err));
    }
    setBusy(false);
  }

  if (sent) {
    return (
      <div className="card stack">
        <h3>Danke, Ihre Nachricht ist bei uns.</h3>
        <p>Wir melden uns so bald wie möglich per E-Mail bei Ihnen.</p>
      </div>
    );
  }
  return (
    <form className="card stack" onSubmit={submit}>
      <h3>Nachricht schreiben</h3>
      <p>Hat Ihnen Vero oder die Hilfe nicht weitergeholfen? Schreiben Sie uns, wir antworten Ihnen persönlich.</p>
      <Field id="name" label="Ihr Name" autoComplete="name" required maxLength={120} />
      <Field id="email" label="Ihre E-Mail-Adresse" type="email" autoComplete="email" required maxLength={254} />
      <div className="field">
        <label htmlFor="message">Ihr Anliegen</label>
        <textarea id="message" name="message" rows={6} required minLength={10} maxLength={4000} />
      </div>
      <div className="hp" aria-hidden="true">
        <label>
          Bitte leer lassen
          <input name="website" tabIndex={-1} autoComplete="off" />
        </label>
      </div>
      <p className="hint" style={{ color: "var(--muted)", fontSize: ".85rem" }}>
        Wir verwenden Ihre Angaben nur, um Ihre Anfrage zu beantworten. Mehr dazu in der <Link to="/rechtliches#datenschutz">Datenschutzerklärung</Link>. Sie erreichen uns
        auch direkt unter {SUPPORT_EMAIL}.
      </p>
      <Notice kind="bad">{error}</Notice>
      <button className="btn btn-primary" disabled={busy} style={{ justifySelf: "start" }}>
        Nachricht senden
      </button>
    </form>
  );
}
